module.exports = __webpack_public_path__ + "img/Tryp_MelillaPuerto.1c5a2994.svg";